import { useEffect } from 'react';
import { KeyboardData } from '../types/hooks';
import { useKeyboard } from './useEditor';

export const keyboardCoreHooks = () => {
  const [keyboard, setKeyboard] = useKeyboard<KeyboardData>();

  const handleKeyDown = (e: KeyboardEvent) => {
    const activeElement = document.activeElement;

    if (activeElement !== document.body && activeElement?.role !== 'treeitem')
      return; // Prevents shortcuts in input fields (e.g. text inputs)
    if (keyboard.keysDown?.includes(e.code)) return;

    if (e.code === 'AltLeft') e.preventDefault(); // Prevent losing focus on window

    setKeyboard({ keysDown: [...(keyboard.keysDown || []), e.code] });
  };
  const handleKeyUp = (e: KeyboardEvent) => {
    setKeyboard({
      keysDown: keyboard.keysDown.filter((key) => key !== e.code),
    });
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  });
};
